export const SECOND = 1000; // milliseconds
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;
export const WEEK = 7 * DAY;
export const NUMBER_OF_DAYS_TO_DISPLAY = 365;
